import styled from "styled-components";
import { theme } from "../../../../helpers/theme";


export const ServicesContianer = styled.div`
  max-width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content:stretch;

  @media ${theme.device.mobileL} {
    max-width: 60%;
  }

  @media ${theme.device.tablet} {
    max-width: 50%;
  }

  @media ${theme.device.laptop} {
    max-width: 40%;
  }
`;

export const Separator = styled.hr`
  width: 100%;
  height: 1px;
  background: ${theme.colors.gray02_border};
`;

export const ServicesHeaderContainer = styled.div``;

export const ServicesHeader = styled.h2``;

export const ServicesSubHeader = styled.p``;

export const ServicesList = styled.div`
// margin-bottom: 50px;
  width: fit-content;
  display:flex;
  flex-direction:column;
  justify-content: space-between;
  align-items:stretch;
  align-content: stretch;//new
  height: 100%;

  @media ${theme.device.laptop} {
    margin-bottom: 0px;
  }
`;

export const ServicesListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-block: 20px;
  
`;

export const ServicesListItemIcon = styled.img`
  margin-right: 20px;
`;

export const ServicesListItemTextContainer = styled.div`
`;

export const ServicesListItemHeader = styled.h3`
  margin-top: 5px;
`;

export const ServicesListItemText = styled.p`
`;

